import styled, { createGlobalStyle } from "styled-components";
import fontVladimir from "../../assets/fonts/vladimir.ttf";

export const GlobalStyle = createGlobalStyle`
  body {
    min-width: 100%;
    min-height: 100vh;
    font-family: "Vladimir";
  }

  @font-face {
    font-family: "Vladimir";
    src: url(${fontVladimir}) format("truetype");
    font-weight: normal;
  }
`;

export const Emphasize = styled.span`
  color: #dc0100;
`;

export const StrikeOut = styled.span`
  text-decoration: line-through;
  font-weight: normal;
`